import { PaperGenerated } from '../paper-generated/paper-generated.model';
import {
  GenerateQuestion,
  QuestionGenerated,
} from '../question-generated/question-generated.model';

export enum PaperGeneratedItemType {
  Title = 'title',
  Description = 'description',
  Question = 'question',
}

export interface PaperGeneratedItem {
  id: number;
  order: number;
  text: string;
  type: PaperGeneratedItemType;
  paperGenerated: PaperGenerated;
  questionGenerated: QuestionGenerated;
  //
  // NOTE: For question in in question
  subOrder: number | null;
  //
  newQuestionGenerateds: GenerateQuestion[];
  selectedNewQuestionGenerated: number | null;
  hasChange: boolean;
}

export interface PaperGeneratedItemsGroup {
  paperGeneratedItems: PaperGeneratedItem[];
  order: number | null;
}

export function getAlphabet(index: number) {
  const alphabets = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
  ];

  return alphabets[index];
}

export function getOrderPaperGeneratedItem(order: number) {
  const orderString = `${order}`;

  const isSubOrder = order % 1 > 0;
  const parentOrder = orderString.split('.')[0];
  const ownOrder = orderString.split('.')[1] || null;

  return {
    order: parseInt(ownOrder ? ownOrder : parentOrder),
    parentOrder: ownOrder ? parseInt(parentOrder) : null,
    isSubOrder,
  };
}
